<template>
  <main>
    <div class="tab-content" :class="{'section-loading': preLoading}">
      <div class="container-fluid">
        <div class="col-12 d-flex align-items-center justify-content-end">資料更新日期：108/2/27</div>
        <div class="list badgets mb-4">
          <span v-for="(item, index) in chText.split(';')" :key="`preChText-${index}`" class="item badget gray">{{ item }}</span>
        </div>
        <div class="" style="min-height:450px;">
          <div class="breadcrumb row" >
            <label class="col-1 text-right">路徑</label>
            <div class="col-11">
              <ul class="breadcrumb-list">
                <li class="bread"
                :class="{'active': bread.index === currentTableIndex}"
                v-for="(bread, i) in breadcrumbs"
                :key="`pre-bread-${i}`">
                  <a v-if="bread.index === currentTableIndex" role="button">{{bread.name}}</a>
                  <a v-else role="button" @click="returnTable(bread, i)">{{bread.name}}</a>
                </li>
              </ul>
            </div>
          </div>

          <table class="table datatable insurance-green" v-if="tableRow && tableRow.length && currentTableIndex !== '7' && currentTableIndex !== '5'">
            <thead>
                <tr>
                  <th class="text-center">序號</th>
                  <th class="text-center">業務系統</th>
                  <th class="text-center">符合條件客戶分佈業務員數</th>
                  <th class="text-center">符合條件客戶數</th>
                </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rid) in tableRow"
              :key="`pre-row-${rid}`">
                  <td class="text-center">{{ rid + 1 }}</td>
                  <td class="text-center">
                    <a class="link text-underline" @click="gotoNext(row)">{{row.cedvnm}}</a>
                    <!-- <span v-else>{{row.type}}</span> -->
                  </td>
                  <td class="text-center">{{ row.agnt_count }}</td>
                  <td class="text-center">{{ row.cust_count }}</td>
                  <!-- <td v-if="row.ta_aglist" class="text-center">{{ row.ta_aglist.cust_count }}</td>
                  <td v-else class="text-center">0</td> -->
              </tr>
            </tbody>
            <tfoot v-if="tableRow && tableRow.length">
              <tr class="bg-white">
                <th class="text-center" colspan="2">合計</th>
                <th class="text-center">{{ sumAngtCount(tableRow) }}</th>
                <th class="text-center">{{ sumCustCount(tableRow) }}</th>
              </tr>
            </tfoot>
          </table>
          <table class="table datatable insurance-green" v-else-if="tableRow && tableRow.length">
            <thead>
                <tr>
                  <th class="text-center">序號</th>
                  <th class="text-center">單位代號</th>
                  <th class="text-center">姓名</th>
                  <th class="text-center">符合條件客戶數</th>
                </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rid) in tableRow"
              :key="`pre-row-${rid}`">
                  <td class="text-center">{{ rid + 1 }}</td>
                  <td class="text-center">
                    <span>{{ row.div_no }}</span>
                  </td>
                  <td class="text-center">{{ row.name }}</td>
                  <td v-if="row.cust_count" class="text-center">{{ row.cust_count }}</td>
                  <td v-else class="text-center">0</td>
              </tr>
            </tbody>
            <tfoot v-if="tableRow && tableRow.length">
              <tr class="bg-white">
                <th class="text-center" colspan="3">合計</th>
                <th class="text-center">{{ sumUnitCount(tableRow) }}</th>
              </tr>
            </tfoot>
          </table>
          <div v-else class="empty-block w-100" >
            <span>{{ errorMsg }}</span>
          </div>
        </div>
        <div class="float-right">
          <button class="btn btn-default" @click="returnUnitCondition">回條件設定</button>
          <button class="btn btn-primary mt-0" @click="goRleaseTable">下一頁</button>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {commonMixin} from '@/mixins/common'
import { getUnitCustCount } from '@/service'
import { setTimeout } from 'timers';

import { log } from 'util';

export default {
  name: 'PreviewClient',
  mixins: [commonMixin],
  props: {
    title: {
      type: String,
      default: ''
    },
    chText: {
      type: String,
      default: ''
    },
    conditionData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    status: {
      type: String,
      default: ''
    },
  },
  watch: {
    status (val) {
      if (val == 'STATUS_PREVIEW_CLIENT') {
        this.getPreviewCount('3') // 初始化客戶數預覽
      }
    }
  },
  computed: {
    wayState () {  //  層級路線狀態值
      if(this.agDivNo[2] == '4') {
        return 'R'
      }
      if(this.agDivNo[2] == '1') {
        return 'S'
      }
      return 'R'
    },
  },
  data () {  //data block layout
    return {
      specialIndexLine: ['3', '7'],  //  專招層級線
      renderIndexLine: ['3', '4', '5'],  //  展業層級線
      dataTree: {
        trace3: [],
        trace4: [],
        trace5: [],
        trace7: [],
      },
      currentTableIndex: '3',
      breadcrumbs: [],
      tableRow: [],
      managerKey: '',
      agDivNo: '',
      agDivName: '',
      preLoading: false,
      errorMsg: "無符合條件名單。"
    }
  },
  methods: {
    getPreviewCount (count, divName, div) {  // 取得客戶數預覽
      this.currentTableIndex = count
      let divno = ''
      if(count == '3'){
        divno = this.$store.state.userInfo.divNo
      } else {
        divno = div
      }
      const reportData = {
        firstcount: count,
        option_ch: this.chText,
        conditions: this.conditionData,
      }
      this.preLoading = true
      this.errorMsg = "無符合條件名單。";
      getUnitCustCount(this.$store.state.userInfo.id, divno, reportData).then(
        result => {
          this.preLoading = false;
          if (result.header) {
            if (result.header.status == "200") {
              this.dataTree["trace" + count] = result.body.dev_list;
              this.tableRow = result.body.dev_list;
              if (count == "3") {
                this.breadcrumbs = [];
                this.breadcrumbs.push({
                  name: this.$store.state.userInfo.divFullName,
                  index: count
                });
              } else {
                this.breadcrumbs.push({ name: divName, index: count });
              }
              this.registerHanlink(); // for 難字update
            } else if (
              result.header.status == "400" &&
              result.header.message &&
              result.header.message == "連線逾時 請重新操作"
            ) {
              this.errorMsg = "客戶數過多，請選擇多個條件縮小範圍";
            } else {
              this.errorMsg = "系統異常，請增加篩選條件縮小範圍或稍後再試";
            }
          }
        }
      );
    },
    gotoNext (item) {  // 往下一層
      let nextIndex = this.handleNextIndex()
      console.log(nextIndex)
      this.getPreviewCount(nextIndex, item.cedvnm, item.cedvno)
    },
    handleNextIndex () {  //  計算下一個層級 api_id
      let nextIndex = ''
      if(this.wayState == 'S') {
        let currIndex = this.specialIndexLine.indexOf(this.currentTableIndex)
        nextIndex = this.specialIndexLine[currIndex + 1]
      } else {
        let currIndex = this.renderIndexLine.indexOf(this.currentTableIndex)
        nextIndex = this.renderIndexLine[currIndex + 1]
      }
      return nextIndex
    },
    returnTable (bread, idx) {  // 回到上一層
      this.tableRow = []
      setTimeout(() => {
        this.tableRow = [...this.dataTree['trace' + bread.index]]
      }, 50);
      this.currentTableIndex = bread.index
      this.breadcrumbs = this.breadcrumbs.slice(0, idx + 1)
      this.checkRegisterHanlink()  // for 難字更新
    },
    checkRegisterHanlink(){
      setTimeout(() => {
        this.registerHanlink()  // for 難字更新
      }, 50)    
    },
    sumAngtCount (tableData) {  // 加總業務員數
      let numAry = tableData.map(item => {
        return Number(item.agnt_count)
      })
      return numAry.reduce((a,b)=>a+b)
    },
    sumCustCount (tableData) {  // 加總符合條件客戶數
      let numAry = tableData.map(item => {
        if(item.cust_count) {
          return Number(item.cust_count)
        } else {
          return 0
        }
      })
      return numAry.reduce((a,b)=>a+b)
    },
    sumUnitCount (tableData) {  // 加總 人員 符合條件客戶數
      let numAry = tableData.map(item => {
        return Number(item.cust_count)
      })
      return numAry.reduce((a,b)=>a+b)
    },
    returnUnitCondition() {
      this.$emit('return-unit-condition')
    },
    goRleaseTable() {
      this.$emit('go-release-table', null, null, null, false)
    }
  },
  mounted() {
    //  設定 職等與單位代號
    this.managerKey = this.$store.state.userInfo.roleId || ''
    this.agDivNo = this.$store.state.userInfo.divNo || ''
    this.agDivName = this.$store.state.userInfo.divFullName || ''
  }
}
</script>
